import React from 'lib/react';
import { Link } from 'lib/router';
import { ORDER_ROUTE } from 'constants/RouteConstants';
import { EVGrid, EVButton } from 'lib/components';
import Typography from 'commonComponents/typography';
import { useTranslation, Trans } from 'lib/translation';
import { VIEWPOINT_URL, SUPPORT_US_USERS } from 'constants/AppConstants';
import { useSelector } from 'lib/redux';
import OrderStyles from '../OrderStyles';

function UnauthorisedSidePanel() {
  const classes = OrderStyles();
  const { t } = useTranslation();

  const geocodedAddress = useSelector(({ orderAddresses }) => orderAddresses.geocodedAddress);
  const addressParams = geocodedAddress ? `?latitude=${geocodedAddress.latitude}&longitude=${geocodedAddress.longitude}` : '';

  return (
    <EVGrid className={classes.searchOpenPageContainer}>
      <EVGrid className={classes.loginContainer}>
        <Typography variant="h2-400" fontColor="charcoal-900">{t('unauthenticated__login_msg')}</Typography>
        <EVGrid className={classes.loginBtnContainer}>
          <EVButton
            variant="contained"
            color="primary"
            className={classes.loginButton}
            type={Link}
            href={`${VIEWPOINT_URL}/myev${ORDER_ROUTE}${addressParams}`}
          >
            {t('unauthenticated__login_Btn')}
          </EVButton>
          <EVButton
            variant="outlined"
            color="primary"
            className={classes.loginButton}
            type={Link}
            href={`${VIEWPOINT_URL}/myev${ORDER_ROUTE}${addressParams}`}
          >
            {t('unauthenticated__create_account_Btn')}
          </EVButton>
        </EVGrid>
      </EVGrid>
      <EVGrid className={classes.loginContainer}>
        <Typography variant="h2-400" fontColor="charcoal-900">{t('unauthenticated__new_exp_title')}</Typography>
        <Typography variant="body-400" fontColor="charcoal-800">{t('unauthenticated__new_exp_msg1')}</Typography>
        <Typography variant="body-400" fontColor="charcoal-800">
          <Trans i18nKey="unauthenticated__new_exp_msg2" />
        </Typography>
        <Typography variant="body-400" fontColor="charcoal-800">
          <Trans
            i18nKey="unauthenticated__new_exp_msg3"
            components={{
              a: (
                <a
                  style={{ color: '#4D5365', textDecoration: 'underline' }}
                  href={SUPPORT_US_USERS}
                >
                  EagleView support
                </a>
              ),
            }}
          />
        </Typography>
      </EVGrid>
      <EVGrid className={classes.loginContainer}>
        <Typography variant="h2-400" fontColor="charcoal-900">{t('unauthenticated__no_account_title')}</Typography>
        <Typography variant="body-400" fontColor="charcoal-800">{t('unauthenticated__no_account_msg')}</Typography>
        <a
          style={{ color: '#007CAD', fontSize: '16px', textDecoration: 'underline' }}
          href={`${VIEWPOINT_URL}/myev${ORDER_ROUTE}${addressParams}`}
        >
          {t('unauthenticated__create_ev_account')}
        </a>
      </EVGrid>
    </EVGrid>
  );
}

export default UnauthorisedSidePanel;
